import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {ProposalSubscribeVerificationFormComponent} from './proposal-subscribe-verification-form.component';
import {ProposalVerificationFormModule} from './proposal-verification-form/proposal-verification-form.module';

@NgModule({
  declarations: [ProposalSubscribeVerificationFormComponent],
  imports: [CommonModule, ProposalVerificationFormModule],
  exports: [ProposalSubscribeVerificationFormComponent],
})
export class ProposalSubscribeVerificationFormModule {}
